import { BePointCampaign, Campaign, PromoTag, RestaurantTier } from "./common"

export interface Dishes {
  icon: string
  classify: number
  restaurant_id: number
  popularity: number
  offers_discount: boolean
  name: string
  review_count: number
  rating: number
  sort_rating: number
  latitude: number
  longitude: number
  image: string
  image_compressed: string
  image_compressed_web: string
  display_address: string
  order_mode: number
  address: string
  delivery_radius: number
  distance: number
  delivery_time: number
  price_range: number
  free_delivery: boolean
  distance_text: string
  next_slot_time: Date
  end_time: Date
  status: Status
  is_closed: boolean
  score: number
  is_partner: number
  offers_title: string[]
  merchant_id: number
  brand_id: number
  city: number
  median_price: number
  created_at: number
  merchant_category_id: number
  ranking_restaurant?: RankingRestaurant
  campaign: Campaign
  restaurant_tier: RestaurantTier
  has_be_point: boolean
  be_point_campaign: BePointCampaign
  store_count: number
  promo_tags: PromoTag[]
  currency_code?: CurrencyCode
  currency?: Currency
  items?: DishItem[]
  out_of_delivery_content?: string
}

enum Currency {
  Empty = "₫",
}

enum CurrencyCode {
  Vnd = "VND",
}

export interface DishItem {
  is_veg: number
  show_food_type: number
  restaurant_item_id: number
  restaurant_id: number
  restaurant_name: string
  restaurant_address: string
  next_slot_time: Date
  end_time: Date
  status: Status
  is_closed: boolean
  price: number
  old_price: number
  offer_text: OfferText
  offers_discount: boolean
  item_image: string
  item_image_compressed: string
  item_image_compressed_web: string
  item_image_compressed_cover: string
  display_price: string
  display_old_price: string
  item_name: string
  item_details: string
  stock_used: number
  order_count: number
  calories: number
  carbs: number
  fats: number
  proteins: number
  customize_item: CustomizeItem[]
  score: number
  is_active: number
  like_count: number
}

export interface CustomizeItem {
  customize_id: number
  customize_item_name: string
  customize_item_limit: number
  customize_item_lower_limit: number
  is_required: boolean
  is_check_box: number
  customize_options: CustomizeOption[]
  position: number
  customize_active: number
}

interface CustomizeOption {
  customize_option_id: number
  customize_option_name: string
  is_default: boolean
  customize_price: number
  customize_display_price: string
  customize_calories: number | null
  customize_fats: number | null
  customize_carbs: number | null
  customize_proteins: number | null
  customize_option_active: number
  customize_option_display_order: number
}

enum OfferText {
  Empty = "",
  Promo = "Promo",
}

enum Status {
  Active = "active",
}

interface RankingRestaurant {
  title: Title
  image: string
}

enum Title {
  Hơn100ĐánhGiá5Sao = "Hơn 100 đánh giá 5 sao",
  ĐãBánHơn1000Đơn = "Đã bán hơn 1000 đơn",
}
